import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faArrowCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import Container from "react-bootstrap/esm/Container";
import "./ContactHero.css";
const ContactHero = () => {
  return (
    <>
      <Container className="hero_contact_wrapper">
        <div className="quick_contact">
          <div className="quick_contact_info">
            <div className="email_info">
              <div>
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <div className="right">
                <h4 className="title">Quick Contact</h4>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "15px",
                  }}
                >
                  <p>Email : </p>
                  <p>info@pradeepautomotive.com</p>
                </div>

                <div
                  style={{
                    display: "flex",

                    gap: "5px",
                    marginTop: "5px",
                  }}
                >
                  <p>Phone : </p>
                  <p>022 23808403</p>
                </div>
              </div>
            </div>
            <div className="location_info">
              <div>
                <FontAwesomeIcon icon={faLocationDot} />
              </div>
              <div className="right">
                <h4 className="title">Our Location</h4>
                <p>
                  <span style={{ fontWeight: "bold", color: "#1b1a1a" }}>
                    Pradeep Automotive Ltd.
                  </span>
                  <br />
                  Phoenix Bldg. B,Shop No. 8, <br />
                  Benham Hall Lane. S.V.P Road. <br />
                  Mumbai(400004)
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="banner_root">
          <div className="banner_wrapper">
            <h5 className="banner_wrapper_title">
              A Leading Developer Of A Grade Commercial & Residential Projects
            </h5>
            <p className="banner_wrapper_info">
              Today Lorel Ipsum has over 4,000 professionals on its payroll All
              Over The World
            </p>
            <a className="banner_contact" href="/#contact">
              Contact us <FontAwesomeIcon icon={faArrowCircleRight} />
            </a>
          </div>
        </div>
      </Container>
    </>
  );
};
export default ContactHero;
